import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Linkedin } from "lucide-react";

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer
      style={{
        backgroundColor: "#f8f9fa",
        borderTop: "1px solid #eaeaea",
        marginTop: "60px",
      }}
      className="pt-5 pb-4"
    >
      <Container>
        <Row className="gy-4">

          {/* Company */}
          <Col md={4}>
            <h5 className="fw-bold mb-3" style={{ color: "#3E826D" }}>
              E&S Solutions
            </h5>
            <p className="text-muted small">
              Technology-driven environmental and social intelligence
              platforms designed for transparency, compliance, and
              sustainable impact.
            </p>
          </Col>

          {/* Support Section */}
          <Col md={4}>
            <h6 className="fw-bold mb-3">Support</h6>
            <p className="text-muted small mb-2">
              Need Help? Reach out to your dedicated contact person or email:
            </p>
            <a
              href="mailto:info@essolutions.ai"
              className="d-block mb-2"
              style={{ color: "#3E826D", textDecoration: "none" }}
            >
              info@essolutions.ai
            </a>

            <Link
              to="/faqs"
              onClick={scrollToTop}
              className="small text-decoration-none"
              style={{ color: "#3E826D" }}
            >
              Visit our FAQ →
            </Link>
          </Col>

          {/* Legal & Links */}
          <Col md={4}>
            <h6 className="fw-bold mb-3">Legal & Policies</h6>

            <div className="d-flex flex-column gap-2 small">
              <Link
                to="/privacy-policy"
                onClick={scrollToTop}
                className="text-decoration-none text-muted"
              >
                Privacy Notice (Updated 2026)
              </Link>

              <Link
                to="/terms-policies"
                onClick={scrollToTop}
                className="text-decoration-none text-muted"
              >
                Terms & Policies
              </Link>

              <Link
                to="/faqs"
                onClick={scrollToTop}
                className="text-decoration-none text-muted"
              >
                FAQ
              </Link>
            </div>

            {/* Socials */}
            <div className="mt-4">
              <h6 className="fw-bold mb-2">Connect</h6>
              <a
                href="https://www.linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="d-inline-flex align-items-center gap-2 text-decoration-none"
                style={{ color: "#3E826D" }}
              >
                <Linkedin size={18} />
                LinkedIn
              </a>
            </div>
          </Col>
        </Row>

        {/* Divider */}
        <hr className="my-4" />

        {/* Copyright */}
        <Row>
          <Col className="text-center small text-muted">
            © 2026 E&S Solutions. All rights reserved.
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;